import { generateKey } from 'constants/helper';

import { BasicEmployee } from './employee';

export class Agenda {
  constructor({ uuid, text, status, macros, uiKey, fromEmployee, label }) {
    this.uuid = uuid;
    this.text = text;
    this.status = status;
    this.macros = macros;
    this.uiKey = uiKey;
    this.fromEmployee = fromEmployee;
    this.label = label;
  }

  static fromJSON({ uuid, text, status, macros, uiKey, fromEmployee = {}, label = {} }) {
    return new Agenda({
      uuid,
      text,
      status,
      macros,
      uiKey: uiKey ?? generateKey(7),
      fromEmployee: BasicEmployee.fromJSON(fromEmployee),
      label: label ? AgendaLabel.fromJSON(label) : null,
    });
  }
}

class AgendaLabel {
  constructor({ uuid, labelType }) {
    this.uuid = uuid;
    this.labelType = labelType;
  }

  static fromJSON({ uuid, labelType }) {
    return new AgendaLabel({
      uuid,
      labelType,
    });
  }
}
